import { render } from "./VideoModal.vue?vue&type=template&id=09db8a60&scoped=true"
import script from "./VideoModal.vue?vue&type=script&lang=js"
export * from "./VideoModal.vue?vue&type=script&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=09db8a60&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09db8a60"]])

export default __exports__